// extracted by mini-css-extract-plugin
export var container = "FeaturedCaseStudy-module--container--1wqya";
export var videoWrapper = "FeaturedCaseStudy-module--videoWrapper--3CP8i";
export var videoInner = "FeaturedCaseStudy-module--videoInner--2eSSD";
export var image = "FeaturedCaseStudy-module--image--2zV5F";
export var video = "FeaturedCaseStudy-module--video--1NVdD";
export var contentContainer = "FeaturedCaseStudy-module--contentContainer--roLSW";
export var testimonial = "FeaturedCaseStudy-module--testimonial--QWf_i";
export var testimonialGrid = "FeaturedCaseStudy-module--testimonialGrid--2K5kK";
export var statList = "FeaturedCaseStudy-module--statList--esuB6";
export var statText = "FeaturedCaseStudy-module--statText--hF6-1";
export var statLabel = "FeaturedCaseStudy-module--statLabel--2noXc";
export var button = "FeaturedCaseStudy-module--button--1yMiT";
export var featuredCaseStudyRtl = "FeaturedCaseStudy-module--featuredCaseStudyRtl--1eEQR";
export var videoContainer = "FeaturedCaseStudy-module--videoContainer--1drZW";
export var show = "FeaturedCaseStudy-module--show--3Q3OA";
export var showFadeInDown = "FeaturedCaseStudy-module--show-fade-in-down--3hktE";
export var showFadeInUp = "FeaturedCaseStudy-module--show-fade-in-up--2sHAv";
export var hideFadeOut = "FeaturedCaseStudy-module--hide-fade-out--2GN1H";